// Bouton "Filtrer" pour ouvrir les filtres en version mobile
const filtersToggler = document.getElementById('toggle-projects-filters');
const categoryTree = document.getElementById('projects-filter');

if (typeof(filtersToggler) != 'undefined' && filtersToggler != null) {
  filtersToggler.addEventListener('click', () => {
    const isActive = filtersToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      filtersToggler.classList.add('active');
      filtersToggler.setAttribute('aria-expanded', 'true');
      categoryTree.classList.add('filters--opened')
    } else {
      filtersToggler.classList.remove('active');
      filtersToggler.setAttribute('aria-expanded', 'false');
      categoryTree.classList.remove('filters--opened')
    }
  });
}

const form = document.getElementById('filter-projet-innovant');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    const domainesStrategiques = [...form.querySelectorAll('input[name="filter-domaines-strategiques"]:checked')]
      .map(i => i.value)
      .join(',');
    if (domainesStrategiques) params.set('filter-domaines-strategiques', domainesStrategiques);

    const guichetFinanceur = [...form.querySelectorAll('input[name="filter-guichet-financeur"]:checked')]
      .map(i => i.value)
      .join(',');
    if (guichetFinanceur) params.set('filter-guichet-financeur', guichetFinanceur);

    const france = [...form.querySelectorAll('input[name="filter-france"]:checked')]
    .map(i => i.value)
    .join(',');
    if (france) params.set('filter-france', france);

    const action = form.getAttribute('action') || window.location.pathname;
    window.location.href = `${action.split('?')[0]}?${params.toString()}`;
  });
}

